import { render, staticRenderFns } from "./feedbackrecord.vue?vue&type=template&id=4dbcdeb6&scoped=true"
import script from "./feedbackrecord.vue?vue&type=script&lang=js"
export * from "./feedbackrecord.vue?vue&type=script&lang=js"
import style0 from "./feedbackrecord.vue?vue&type=style&index=0&id=4dbcdeb6&lang=scss&scoped=true"
import style1 from "./feedbackrecord.vue?vue&type=style&index=1&id=4dbcdeb6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbcdeb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbcdeb6')) {
      api.createRecord('4dbcdeb6', component.options)
    } else {
      api.reload('4dbcdeb6', component.options)
    }
    module.hot.accept("./feedbackrecord.vue?vue&type=template&id=4dbcdeb6&scoped=true", function () {
      api.rerender('4dbcdeb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/feedbackrecord.vue"
export default component.exports